import React from 'react'
import Styled from 'styled-components'

import Icon from 'components/Icon'
import Link from 'components/Link'

const Container = Styled(Link)`
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 100%;
  color: ${props => props.theme.colors.gray.shade200};
  transition: 300ms;
  cursor: pointer;

  &:hover {
    color: ${props => props.theme.colors.gray.shade300};
  }
`

const IconExtended = Styled(Icon)`
  font-size: 1.5rem;
`

const Label = Styled.div`
  font-family: ${props => props.theme.fonts.regular};
  font-size: 0.8rem;
  font-weight: 600;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  margin-left: 1rem;
`

export default props => (
  <Container to={props.to}>
    <IconExtended liga="arrow_back" />
    <Label>{props.children}</Label>
  </Container>
)



// WEBPACK FOOTER //
// ./src/components/NavigationBack/index.js